<template>
  <div>
    <arrange v-show="activeKey===1" ref="orders" @goDetails="goDetails" @goWaves="goWaves"/>
    <release v-show="activeKey===2" ref="waves" @back="back"/>
    <shipment-order-detail v-show="activeKey===3" ref="details" @back="back"/>
  </div>
</template>
<script>
import ShipmentOrderDetail from '@/views/outbound/dispatch_order/ShipmentOrderDetail'
import Arrange from '@/views/outbound/dispatch_order/ShipmentArrange.vue'
import Release from '@/views/outbound/dispatch_order/ShipmentRelease.vue'

export default {
  name: 'ShipmentDispatch',
  components: { Arrange, Release, ShipmentOrderDetail },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.orders.fetch()
    },
    goWaves() {
      this.activeKey = 2
      this.$refs.waves.refresh()
    },
    goDetails(record) {
      this.activeKey = 3
      this.$refs.details.fetch(record)
    }
  }
}
</script>